import { gql } from '@apollo/client';

export const ON_USES_DEPLETED = gql`
  subscription OnUsesDepleted($installationId: UUID!) {
    onUsesDepleted(installationId: $installationId)
  }
`;
